import React from "react";

const Payment = () => {
  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>Donate to Pravartan</h1>
      <p>Thank you for supporting our mission ❤️</p>
      
      <form style={{ marginTop: "30px" }}>
        <input 
          type="text" 
          placeholder="Full Name" 
          style={{ padding: "10px", margin: "10px", width: "250px" }} 
        />
        <br />
        <input 
          type="email" 
          placeholder="Email Address" 
          style={{ padding: "10px", margin: "10px", width: "250px" }} 
        />
        <br />
        <input 
          type="number" 
          placeholder="Donation Amount (₹)" 
          style={{ padding: "10px", margin: "10px", width: "250px" }} 
        />
        <br />
        <button 
          type="submit" 
          style={{
            background: "#d60000",
            color: "white",
            padding: "12px 25px",
            border: "none",
            borderRadius: "25px",
            cursor: "pointer",
            marginTop: "15px"
          }}
        >
          Proceed to Pay
        </button>
      </form>
    </div>
  );
};

export default Payment;
